module.exports = __webpack_public_path__ + "static/scale-model-of-clarksville-tennessee-4fc175263da0977aa72e569d89db949b.png";